__turbopack_context__.v({
  "accordion_contents": "Landing-module-scss-module__XXz4la__accordion_contents",
  "app-side-padding": "Landing-module-scss-module__XXz4la__app-side-padding",
  "apply-possible-content-wrapper": "Landing-module-scss-module__XXz4la__apply-possible-content-wrapper",
  "business_name": "Landing-module-scss-module__XXz4la__business_name",
  "bznav-main": "Landing-module-scss-module__XXz4la__bznav-main",
  "cta_tooltip": "Landing-module-scss-module__XXz4la__cta_tooltip",
  "divider": "Landing-module-scss-module__XXz4la__divider",
  "duration_fast": "Landing-module-scss-module__XXz4la__duration_fast",
  "fullcare-main": "Landing-module-scss-module__XXz4la__fullcare-main",
  "fullcare-sub": "Landing-module-scss-module__XXz4la__fullcare-sub",
  "grid_card": "Landing-module-scss-module__XXz4la__grid_card",
  "heading-1": "Landing-module-scss-module__XXz4la__heading-1",
  "heading-2": "Landing-module-scss-module__XXz4la__heading-2",
  "heading-3": "Landing-module-scss-module__XXz4la__heading-3",
  "heading-4": "Landing-module-scss-module__XXz4la__heading-4",
  "heading-5": "Landing-module-scss-module__XXz4la__heading-5",
  "heading-6": "Landing-module-scss-module__XXz4la__heading-6",
  "heading-7": "Landing-module-scss-module__XXz4la__heading-7",
  "heading-8": "Landing-module-scss-module__XXz4la__heading-8",
  "help_text_button": "Landing-module-scss-module__XXz4la__help_text_button",
  "highlight": "Landing-module-scss-module__XXz4la__highlight",
  "highlight-gradient": "Landing-module-scss-module__XXz4la__highlight-gradient",
  "image_section": "Landing-module-scss-module__XXz4la__image_section",
  "imbank_badge": "Landing-module-scss-module__XXz4la__imbank_badge",
  "inform": "Landing-module-scss-module__XXz4la__inform",
  "item_content": "Landing-module-scss-module__XXz4la__item_content",
  "lookup-result-layout": "Landing-module-scss-module__XXz4la__lookup-result-layout",
  "marquee": "Landing-module-scss-module__XXz4la__marquee",
  "notice-container": "Landing-module-scss-module__XXz4la__notice-container",
  "nudge_text_last_line": "Landing-module-scss-module__XXz4la__nudge_text_last_line",
  "nudge_text_line": "Landing-module-scss-module__XXz4la__nudge_text_line",
  "outline": "Landing-module-scss-module__XXz4la__outline",
  "paragraph-0": "Landing-module-scss-module__XXz4la__paragraph-0",
  "paragraph-1": "Landing-module-scss-module__XXz4la__paragraph-1",
  "paragraph-2": "Landing-module-scss-module__XXz4la__paragraph-2",
  "paragraph-3": "Landing-module-scss-module__XXz4la__paragraph-3",
  "paragraph-4": "Landing-module-scss-module__XXz4la__paragraph-4",
  "paragraph-5": "Landing-module-scss-module__XXz4la__paragraph-5",
  "paragraph-6": "Landing-module-scss-module__XXz4la__paragraph-6",
  "paragraph-7": "Landing-module-scss-module__XXz4la__paragraph-7",
  "paragraph-8": "Landing-module-scss-module__XXz4la__paragraph-8",
  "play_button": "Landing-module-scss-module__XXz4la__play_button",
  "refund-hero": "Landing-module-scss-module__XXz4la__refund-hero",
  "refund-investor": "Landing-module-scss-module__XXz4la__refund-investor",
  "refund-main": "Landing-module-scss-module__XXz4la__refund-main",
  "refund-sub": "Landing-module-scss-module__XXz4la__refund-sub",
  "ribbon-inform": "Landing-module-scss-module__XXz4la__ribbon-inform",
  "ribbon-inform-btn": "Landing-module-scss-module__XXz4la__ribbon-inform-btn",
  "shimmer": "Landing-module-scss-module__XXz4la__shimmer",
  "slide_item": "Landing-module-scss-module__XXz4la__slide_item",
  "slide_list": "Landing-module-scss-module__XXz4la__slide_list",
  "slide_track": "Landing-module-scss-module__XXz4la__slide_track",
  "special_background": "Landing-module-scss-module__XXz4la__special_background",
  "text_bottom": "Landing-module-scss-module__XXz4la__text_bottom",
  "text_section": "Landing-module-scss-module__XXz4la__text_section",
  "text_top": "Landing-module-scss-module__XXz4la__text_top",
  "thumbnail": "Landing-module-scss-module__XXz4la__thumbnail",
  "thumbnail_background": "Landing-module-scss-module__XXz4la__thumbnail_background",
  "trace-in": "Landing-module-scss-module__XXz4la__trace-in",
  "trace-out": "Landing-module-scss-module__XXz4la__trace-out",
  "youtube_item": "Landing-module-scss-module__XXz4la__youtube_item",
});
